import { render } from "./Benefits.vue?vue&type=template&id=53427988&scoped=true"
const script = {}

import "./Benefits.vue?vue&type=style&index=0&id=53427988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53427988"]])

export default __exports__